import Vue from "vue";
import Component from "vue-class-component";
import { Nullable } from "@/general/custom-types/CustomTypes";

@Component({})
export class FormContainer<M> extends Vue {
  model: Nullable<M>;
  loading: boolean = true;
  title: Nullable<string>;

  head() {
    return {
      title: this.title
    };
  }

  async created() {
    this.loading = true;
    console.log(this.model);
    this.model = await this.formApi();
    console.log(this.model);

    this.loading = false;
  }

  async formApi(): Promise<M> {
    throw new Error("Method not implement");
  }
}
